var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4626",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 22.7739 34.1036 27.3523 30.7279 30.7279C27.3523 34.1036 22.7739 36 18 36C13.2261 36 8.64774 34.1036 5.27208 30.7279C1.89643 27.3523 0 22.7739 0 18C0 13.2261 1.89643 8.64773 5.27208 5.27208C8.64774 1.89642 13.2261 0 18 0C22.7739 0 27.3523 1.89642 30.7279 5.27208C34.1036 8.64773 36 13.2261 36 18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00878906 35.9961L0.00878906 23.9977H36.004V35.9961H0.00878906Z",
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00878906 23.9978L0.00878906 11.9994L36.004 11.9994V23.9978L0.00878906 23.9978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00878906 11.9993L0.00878906 0.000868797L36.004 0.000868797V11.9993L0.00878906 11.9993Z",
    fill: "#F39C12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 23.251C20.8982 23.251 23.2475 20.9016 23.2475 18.0035C23.2475 15.1055 20.8982 12.7561 18.0001 12.7561C15.102 12.7561 12.7527 15.1055 12.7527 18.0035C12.7527 20.9016 15.102 23.251 18.0001 23.251Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 22.5949C20.536 22.5949 22.5917 20.5392 22.5917 18.0034C22.5917 15.4675 20.536 13.4119 18.0002 13.4119C15.4644 13.4119 13.4087 15.4675 13.4087 18.0034C13.4087 20.5392 15.4644 22.5949 18.0002 22.5949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 18.9218C18.5072 18.9218 18.9184 18.5107 18.9184 18.0035C18.9184 17.4963 18.5072 17.0852 18.0001 17.0852C17.4929 17.0852 17.0818 17.4963 17.0818 18.0035C17.0818 18.5107 17.4929 18.9218 18.0001 18.9218Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5222 18.8302C22.6479 18.8469 22.7632 18.7584 22.7798 18.6327C22.7965 18.507 22.708 18.3917 22.5823 18.3751C22.4566 18.3584 22.3413 18.4469 22.3247 18.5726C22.308 18.6983 22.3965 18.8136 22.5222 18.8302Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22.5948L18.1574 19.8399L18 18.5281L17.8425 19.8399L18 22.5948Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1542 19.9733C22.2713 20.0219 22.4056 19.9663 22.4542 19.8492C22.5028 19.7321 22.4473 19.5978 22.3302 19.5492C22.2131 19.5006 22.0788 19.5561 22.0302 19.6732C21.9816 19.7903 22.0371 19.9247 22.1542 19.9733Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8107 22.4387L17.6763 19.8183L17.864 18.5103L17.3721 19.7367L16.8107 22.4387Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5027 20.9805C21.6032 21.0578 21.7474 21.0389 21.8246 20.9383C21.9018 20.8378 21.8829 20.6937 21.7824 20.6164C21.6819 20.5392 21.5377 20.5581 21.4605 20.6586C21.3833 20.7592 21.4021 20.9033 21.5027 20.9805Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.704 21.9797L17.2178 19.6726L17.7374 18.4579L16.9451 19.5152L15.704 21.9797Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6126 21.7864C20.6897 21.8871 20.8338 21.9061 20.9344 21.829C21.0351 21.7519 21.0541 21.6078 20.977 21.5072C20.8999 21.4065 20.7558 21.3875 20.6552 21.4646C20.5545 21.5417 20.5355 21.6858 20.6126 21.7864Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7527 21.2497L16.8126 19.4132L17.6291 18.3743L16.59 19.1905L14.7527 21.2497Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5448 22.3334C19.5933 22.4506 19.7275 22.5063 19.8447 22.4578C19.9619 22.4094 20.0176 22.2751 19.9691 22.1579C19.9206 22.0408 19.7864 21.9851 19.6692 22.0335C19.552 22.082 19.4964 22.2163 19.5448 22.3334Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0237 20.2993L16.4882 19.0582L17.5455 18.266L16.3307 18.7856L14.0237 20.2993Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3709 22.5861C18.3874 22.7118 18.5027 22.8004 18.6284 22.7839C18.7541 22.7674 18.8427 22.6522 18.8262 22.5265C18.8097 22.4007 18.6945 22.3122 18.5688 22.3286C18.443 22.3451 18.3545 22.4604 18.3709 22.5861Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5644 19.1915L16.2665 18.6308L17.4931 18.1394L16.1851 18.3267L13.5644 19.1915Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1732 22.5253C17.1566 22.651 17.245 22.7664 17.3707 22.783C17.4964 22.7996 17.6117 22.7112 17.6284 22.5855C17.645 22.4598 17.5566 22.3444 17.4309 22.3278C17.3052 22.3112 17.1898 22.3996 17.1732 22.5253Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4088 18.0034L16.1635 18.1608L17.4753 18.0034L16.1635 17.8459L13.4088 18.0034Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0302 22.1571C15.9816 22.2742 16.0371 22.4086 16.1542 22.4572C16.2713 22.5058 16.4056 22.4502 16.4542 22.3331C16.5028 22.216 16.4473 22.0817 16.3302 22.0331C16.2131 21.9845 16.0788 22.04 16.0302 22.1571Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5649 16.8142L16.1852 17.6797L17.4932 17.8674L16.2667 17.3756L13.5649 16.8142Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0236 21.5066C14.9463 21.6072 14.9652 21.7513 15.0658 21.8286C15.1664 21.9058 15.3105 21.8869 15.3877 21.7863C15.465 21.6858 15.4461 21.5416 15.3455 21.4644C15.2449 21.3872 15.1008 21.4061 15.0236 21.5066Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0239 15.7077L16.3313 17.2215L17.5463 17.7411L16.4888 16.9488L14.0239 15.7077Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2172 20.6167C14.1165 20.6939 14.0974 20.838 14.1746 20.9386C14.2517 21.0393 14.3958 21.0583 14.4965 20.9812C14.5971 20.9041 14.6162 20.76 14.5391 20.6593C14.4619 20.5587 14.3178 20.5396 14.2172 20.6167Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7537 14.756L16.5905 16.816L17.6296 17.6326L16.8132 16.5933L14.7537 14.756Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6707 19.5487C13.5535 19.5972 13.4978 19.7314 13.5463 19.8486C13.5947 19.9658 13.729 20.0215 13.8462 19.973C13.9634 19.9245 14.0191 19.7903 13.9706 19.6731C13.9221 19.5559 13.7878 19.5002 13.6707 19.5487Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7045 14.0271L16.9458 16.4917L17.7382 17.5492L17.2185 16.3343L15.7045 14.0271Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4178 18.3748C13.2921 18.3913 13.2035 18.5066 13.22 18.6323C13.2364 18.758 13.3517 18.8466 13.4774 18.8301C13.6032 18.8136 13.6917 18.6984 13.6753 18.5726C13.6588 18.4469 13.5435 18.3584 13.4178 18.3748Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8124 13.5677L17.3732 16.2701L17.8648 17.4968L17.6774 16.1886L16.8124 13.5677Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4778 17.1768C13.3521 17.1602 13.2367 17.2486 13.2201 17.3744C13.2035 17.5001 13.2919 17.6154 13.4177 17.632C13.5434 17.6486 13.6587 17.5602 13.6753 17.4345C13.6919 17.3088 13.6035 17.1934 13.4778 17.1768Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.4117L17.8428 16.1668L18.0003 17.4788L18.1576 16.1668L18 13.4117Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.846 16.0338C13.7289 15.9852 13.5945 16.0407 13.546 16.1579C13.4974 16.275 13.5529 16.4093 13.67 16.4579C13.7871 16.5065 13.9215 16.451 13.9701 16.3338C14.0187 16.2167 13.9631 16.0824 13.846 16.0338Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1896 13.568L18.3241 16.1887L18.1365 17.4968L18.6283 16.2702L19.1896 13.568Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4978 15.0268C14.3972 14.9495 14.2531 14.9684 14.1758 15.069C14.0986 15.1695 14.1175 15.3137 14.2181 15.3909C14.3186 15.4681 14.4628 15.4492 14.54 15.3487C14.6172 15.2481 14.5983 15.104 14.4978 15.0268Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2966 14.027L18.7829 16.3343L18.2633 17.5492L19.0556 16.4917L20.2966 14.027Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3879 14.2206C15.3108 14.12 15.1667 14.1009 15.066 14.178C14.9654 14.2551 14.9463 14.3993 15.0234 14.4999C15.1006 14.6005 15.2447 14.6196 15.3453 14.5425C15.446 14.4654 15.465 14.3212 15.3879 14.2206Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2482 14.757L19.1884 16.5938L18.3718 17.6328L19.411 16.8165L21.2482 14.757Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.455 13.6734C16.4066 13.5562 16.2723 13.5005 16.1551 13.549C16.0379 13.5974 15.9822 13.7317 16.0307 13.8489C16.0791 13.966 16.2134 14.0218 16.3306 13.9733C16.4478 13.9248 16.5035 13.7906 16.455 13.6734Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9766 15.7077L19.5118 16.9488L18.4542 17.7411L19.6692 17.2215L21.9766 15.7077Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6291 13.4203C17.6127 13.2945 17.4974 13.206 17.3717 13.2224C17.2459 13.2389 17.1574 13.3541 17.1738 13.4799C17.1903 13.6056 17.3055 13.6942 17.4313 13.6777C17.557 13.6613 17.6456 13.546 17.6291 13.4203Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4359 16.8157L19.7334 17.3762L18.5066 17.8677L19.8149 17.6804L22.4359 16.8157Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8271 13.481C18.8437 13.3553 18.7553 13.2399 18.6296 13.2233C18.5039 13.2067 18.3885 13.2951 18.3719 13.4208C18.3553 13.5465 18.4437 13.6619 18.5694 13.6785C18.6951 13.6952 18.8105 13.6067 18.8271 13.481Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5917 18.0037L19.8366 17.8461L18.5247 18.0035L19.8366 18.161L22.5917 18.0037Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9704 13.849C20.019 13.7319 19.9635 13.5975 19.8463 13.5489C19.7292 13.5003 19.5949 13.5558 19.5463 13.673C19.4977 13.7901 19.5532 13.9244 19.6703 13.973C19.7874 14.0216 19.9218 13.9661 19.9704 13.849Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4353 19.1928L19.8147 18.327L18.5066 18.1392L19.7331 18.6311L22.4353 19.1928Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9776 14.5003C21.0549 14.3997 21.036 14.2556 20.9354 14.1783C20.8349 14.1011 20.6908 14.12 20.6135 14.2205C20.5363 14.3211 20.5551 14.4652 20.6557 14.5425C20.7563 14.6197 20.9004 14.6008 20.9776 14.5003Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9765 20.2994L19.6693 18.7854L18.4545 18.2658L19.5119 19.0581L21.9765 20.2994Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7835 15.3909C21.8842 15.3138 21.9033 15.1696 21.8262 15.069C21.749 14.9683 21.6049 14.9493 21.5043 15.0264C21.4036 15.1035 21.3845 15.2476 21.4617 15.3483C21.5388 15.4489 21.6829 15.468 21.7835 15.3909Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2465 21.2513L19.4099 19.1912L18.3709 18.3745L19.1871 19.4138L21.2465 21.2513Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3298 16.4589C22.4469 16.4104 22.5027 16.2762 22.4542 16.159C22.4057 16.0418 22.2715 15.9861 22.1543 16.0346C22.0371 16.083 21.9814 16.2173 22.0299 16.3345C22.0783 16.4516 22.2126 16.5074 22.3298 16.4589Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2956 21.9804L19.0546 19.5156L18.2623 18.4582L18.7819 19.6731L20.2956 21.9804Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5829 17.6325C22.7086 17.6161 22.7972 17.5008 22.7807 17.3751C22.7643 17.2494 22.649 17.1608 22.5233 17.1772C22.3976 17.1937 22.309 17.309 22.3255 17.4347C22.3419 17.5604 22.4572 17.649 22.5829 17.6325Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1876 22.4394L18.6272 19.737L18.1357 18.5103L18.323 19.8185L19.1876 22.4394Z",
    fill: "#000088"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.4f5ebc4689baafadb7883bbd8b687000.svg";
export { ForwardRef as ReactComponent };